import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableAsyncReportGeneration = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableAsyncReportGeneration);
};
